<div class="content">
  <!-- Begin dashboard -->
  <div class="container-fluid" style="max-height: 860px;">
    <!-- Page Heading -->
    <div class="row">
      <div class="col d-flex align-items-center justify-content-between mb-4">
        <h1 class="dashboard-title">Offices</h1>
      </div>
    </div>

    <!-- Content Row -->
    <div class="row">
      <div class="col-12  d-flex align-items-center justify-content-between pb-2">
        <!-- Search Box -->
        <div class="col-lg-9 col-md-8">
          <div class="google-search-container">

            <i class="fa fa-search search-icon"></i>

            <input
              (keyup)="handleKeyUp($event)"
              [(ngModel)]="searchText"
              #searchBox
              class="google-search-input"
              type="text"
              placeholder="Search Office..."
            />

            <i
              *ngIf="searchBox.value"
              class="fa fa-times clear-icon"
              (click)="clearSearch(searchBox)"
            ></i>

          </div>
        </div>

        <!-- Filter and Add Buttons -->
        <div class="col-lg-3 col-md-4 d-flex justify-content-end">
          <div class="btn-group btn-group-toggle" data-toggle="buttons">
            <button class="btn btn-success" style="background-color: #8bc34a" (click)="_fetchData(2)">
              Active
            </button>
            <button class="btn btn-danger" (click)="_fetchData(3)"> Inactive</button>
            <button class="btn btn-secondary active" (click)="_fetchData(1)"> All</button>
          </div>&nbsp;&nbsp;

          <!-- <div class="btn-group">
           &lt;!&ndash; Main button with icon and router &ndash;&gt;
           <button
             class="btn btn-primary btn-sm mx-1"
             type="button"
             title="Questionnaire"
             [disabled]="!authService.hasRole('client-edit') || !selectedPlanForIcon"
             [routerLink]="['/questionnaire']"
             [queryParams]="{ planCreation: selectedPlanForIcon }"
           >
             <i class="fa-solid fa-question"></i>
           </button>

           &lt;!&ndash; Dropdown toggle &ndash;&gt;
           <button
             type="button"
             class="btn btn-primary btn-sm dropdown-toggle dropdown-toggle-split"
             [disabled]="!authService.hasRole('client-edit')"
             data-toggle="dropdown"
             aria-haspopup="true"
             aria-expanded="false"
           >
             <span class="sr-only">Toggle Dropdown</span>
           </button>

           &lt;!&ndash; Dropdown menu &ndash;&gt;
           <div class="dropdown-menu">
             <a class="dropdown-item">Select Plan Creation :</a>
             <a class="dropdown-item" (click)="onSelectPlanIcon('YES')">Yes</a>
             <a class="dropdown-item" (click)="onSelectPlanIcon('NO')">No</a>
           </div>
         </div>-->
          <button class="btn btn-primary mx-1" type="button"  title="Questionnaire"
                  [disabled]="!this.authService.hasRole('client-edit')" [routerLink] = "['/questionnaire']">
            <i class="fa-solid fa-question"></i>
          </button>

          <button class="btn btn-primary mx-1" type="button" (click)="openModal()" title="Upload questionnaire Template"
                  [disabled]="!this.authService.hasRole('client-edit')">
            <i class="fa-solid fa-upload"></i>
          </button>

          <button *ngIf="this.authService.hasRole('client-edit')" class="btn btn-primary btn-add-patient" type="button" routerLink="register" title="Add Patient">
            <i class="fas fa-plus me-1"></i> <span class="btn-label">Add Office</span>
          </button>
        </div>
      </div>

      <!-- Table -->
      <div class="col-12">
          <div class="table-panel p-4">
            <div class="table-responsive table-scroll-x">
              <table class="table table-sm" matSort (matSortChange)="sortData($event)">
                <thead>
                <tr>
                  <th scope="col">Sr.No
                  <th *ngIf="this.authService.hasRole('client-edit')" scope="col"><input
                    type="checkbox" [checked]="checked" (click)="assign('All')">&nbsp;
                    Select
                  </th>
                  <th mat-sort-header="name" scope="col">Name</th>
                  <th mat-sort-header="email" scope="col">Email</th>
                  <th mat-sort-header="contact" scope="col">Contact</th>
                  <th mat-sort-header="address" scope="col">Address</th>
                  <th scope="col">Questionnaire</th>
                  <th mat-sort-header="template" scope="col">Template</th>
                  <th mat-sort-header="rules" scope="col">Rules</th>
                  <th mat-sort-header="status" scope="col">Status</th>
                  <th scope="col">Action</th>
                </tr>
                </thead>
                <tbody *ngFor="let table of tableData| filter: searchText; let i = index">
                <tr>
                  <th scope="row">{{i + 1}}</th>
                  <td *ngIf="this.authService.hasRole('client-edit')"><input type="checkbox"
                                                                             [checked]="table.assignedF"
                                                                             (click)="assign(table.id)">
                  </td>
                  <td><a [routerLink]="this.authService.hasRole('client-edit') ? ['details/', table.id]:null">{{table?.name ?  table.name : '-'}}</a></td>
                  <td>{{table.contact?.email ? table.contact.email : '-'}}</td>
                  <td>{{table?.contact?.phones[0]?.number ? table.contact.phones[0].number : '-'}}</td>
                  <td>{{table?.address?.firstLine ? table.address.firstLine + ' ' + table.address.secondLine + ' '+ table.address.city + ' ' + table.address.state + ' ' + table.address.zip : '-'}}</td>
                  <td>
                    <div class="btn-group">
                      <!-- Main button to route -->
                      <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        [routerLink]="authService.hasAnyRole(['client-view','client-edit']) && selectedPlan[table.id] ? ['/questionnaire', table.id] : null"
                        [queryParams]="{ planCreation: selectedPlan[table.id] }"
                        [disabled]="!selectedPlan[table.id]"
                      >
                        Questionnaire
                      </button>

                      <!-- Dropdown toggle -->
                      <button
                        type="button"
                        class="btn btn-primary btn-sm dropdown-toggle dropdown-toggle-split"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span class="sr-only">Toggle Dropdown</span>
                      </button>

                      <!-- Dropdown menu -->
                      <div class="dropdown-menu" id="questionDropdown">
                        <a class="dropdown-item">Select Plan Creation :</a>
                        <a class="dropdown-item" (click)="onSelectPlan('YES', table.id)">Yes</a>
                        <a class="dropdown-item" (click)="onSelectPlan('NO', table.id)">No</a>
                      </div>
                    </div>
                  </td>

                  <td>

                    <div class="btn-group">
                      <button type="button" class="btn btn-primary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa-solid fa-eye"></i> View File
                      </button>
                      <div class="dropdown-menu">
                        <a class="dropdown-item" disabled>Plan Creation</a>
                        <a class="dropdown-item" (click)="exportViewFile(table.id, 'Template', 'yes')"> Yes</a>
                        <a class="dropdown-item" (click)="exportViewFile(table.id, 'Template', 'no')"> No</a>
                      </div>
                    </div>

                  </td>
                  <td>
                    <button  class="btn btn-primary" type="button" [routerLink]="['rules/', table.id]" title="Rules">
                      <i class="fa-solid fa-scale-balanced"></i>&nbsp; Rules
                    </button>
                  </td>


                  <!--<td>
                      <button class="btn btn-info" (click)="exportViewFile(table.id, 'Template')" title="View File">
                          <i class="fa-solid fa-eye"></i>
                      </button>
                      &lt;!&ndash;<a   [href]="table.uploadedFileUrl" target="_blank"  class="btn btn-success" title="View File">
                          <i class="fa-solid fa-eye"></i>
                      </a>&ndash;&gt;
                  </td>-->
                  <td *ngIf="table.active"><i class="fa-solid fa-square-check"
                                              style="color: #34ce57"></i></td>
                  <td *ngIf="!table.active"><i class="fa-solid fa-square-check "
                                               style="color: #dc3545"></i></td>
                  <td>
                    <a title="Edit" [routerLink]="this.authService.hasRole('client-edit') ? ['details/', table.id]: null"><i class="fa-solid fa-user-pen"></i></a>&nbsp;&nbsp;
                    <a title="Delete" (click)="deleteEntry(table.id)" ><i class="fa-solid fa-trash" style="color: #d33636;"></i></a>
                  </td>
                </tr>
                </tbody>
                <tbody *ngIf="tableData == null || tableData.length == 0">
                <tr>
                  <td colspan="7" class="text-center"> No record found !</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="tableData?.length !== 0" class="d-flex justify-content-end mt-3">
              <mat-paginator
                [length]="totalRecord"
                [pageIndex]="pagination.currentPage"
                [pageSize]="pagination.size"
                [pageSizeOptions]="[5, 10, 25, 100, 200, 500, 800, 1000]"
                aria-label="Select page"
                showFirstLastButtons
                color="warn"
                (page)="pageChange($event)">
              </mat-paginator>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>

<div #bulkUpload class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Template Upload</h3>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <!-- Plan Creation Dropdown -->
          <!--<div class="form-group mt-3">
              <label for="planCreation">Plan Creation</label>
              <select id="planCreation" class="form-control" [(ngModel)]="selectedPlanOption" name="planCreation">
                  <option value="" disabled selected>Select an option</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                  <option value="both">Both</option>
              </select>
          </div>-->

          <!-- File Upload Section -->
          <div *ngIf="!fileImage" class="dropzone" (dragover)="onDragOver($event)"
               (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
               [ngClass]="{'is-dragover': isDragOver}">
            <input type="file" #fileDropRef id="fileDropRef" (change)="onFilesSelected($event)"
                   accept=".xls, .xlsx, .xlsm, .xlsb, .xltx, .xltm, .csv, .txt"/>
            <h3 *ngIf="!fileImage">Drag and drop files here</h3>
            <label for="fileDropRef" *ngIf="!fileImage">Browse for files</label>
          </div>

          <div *ngIf="fileImage" class="image-container">
            <img [src]="fileImage" alt="Uploaded File" class="uploaded-image"/>
            <button class="remove-btn" (click)="removeImage()">X</button>
          </div>

          <div class="row pt-4" *ngIf="files?.length > 0">
            <h4>Selected File:</h4>
            <ul>
              <li *ngFor="let file of files">{{ file.name }}</li>
            </ul>
          </div>
          <div class="form-group mt-3">
            <label for="planCreation">Plan Creation<span class="text-danger">*</span></label>
            <select id="planCreation"
                    class="form-control"
                    [(ngModel)]="selectedPlanOption"
                    name="planCreation"
                    required
                    #planCreationRef="ngModel">
              <option value="" disabled>Select an option</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
              <option value="both">Both</option>
            </select>
            <div class="text-danger mt-1" *ngIf="planCreationRef.invalid && planCreationRef.touched">
              Please select a Plan Creation option.
            </div>
          </div>

        </form>
      </div>

      <!-- Error Messages -->
      <div *ngIf="errorMessagePart" class="error-message">
        <h4>{{ errorMessagePart }}</h4>
        <ul *ngIf="errorMessages.length > 0">
          <li *ngFor="let error of errorMessages">{{ error }}</li>
        </ul>
      </div>

      <!-- Footer Buttons -->
      <div class="modal-footer">

        <button *ngIf="files?.length && selectedPlanOption !== ''" type="button" class="btn btn-primary" (click)="uploadFiles()">Upload</button>
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>
</div>

<!--<div #bulkUpload class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">Template Upload</h3>
                <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <div *ngIf="!fileImage" class="dropzone" (dragover)="onDragOver($event)"
                         (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
                         [ngClass]="{'is-dragover': isDragOver}">
                        <input type="file" #fileDropRef id="fileDropRef" (change)="onFilesSelected($event)"
                               accept=".xls, .xlsx, .xlsm, .xlsb, .xltx, .xltm, .csv, .txt"/>
                        <h3 *ngIf="!fileImage">Drag and drop files here</h3>
                        <label for="fileDropRef" *ngIf="!fileImage">Browse for files</label>
                    </div>
                    <div *ngIf="fileImage" class="image-container">
                        <img [src]="fileImage" alt="Uploaded File" class="uploaded-image"/>
                        <button class="remove-btn" (click)="removeImage()">X</button>
                    </div>

                    <div class="row pt-4" *ngIf="files?.length > 0">
                        <h4>Selected File:</h4>
                        <ul>
                            <li *ngFor="let file of files">{{ file.name }}</li>
                        </ul>
                    </div>
                </form>
            </div>
            <div *ngIf="errorMessagePart" class="error-message">
                <h4>{{ errorMessagePart }}</h4>
                <ul *ngIf="errorMessages.length > 0">
                    <li *ngFor="let error of errorMessages">{{ error }}</li>
                </ul>
            </div>
            <div class="modal-footer">
                &lt;!&ndash;                <button type="button" class="btn btn-link download-template" (click)="downloadTemplate()">&ndash;&gt;
                &lt;!&ndash;                  Download Template&ndash;&gt;
                &lt;!&ndash;                </button>&ndash;&gt;
                &lt;!&ndash;<a href="assets/templates/workorder-upload-template.xlsx" download class="btn-slide2">
                    <span class="circle2"><i class="fa fa-download"></i></span>
                    <span class="title2">Download Template</span>
                    <span class="title-hover2">Click here</span>
                </a>&ndash;&gt;
                <button *ngIf="files?.length" type="button" class="btn btn-primary" (click)="uploadFiles()">Upload
                </button>
                <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
            </div>
        </div>
    </div>
</div>-->
